export default __webpack_public_path__ + "static/media/northeastern.9afe82eb.jpg";